import { P } from "apparatus/library/common";
import { BasicShapes } from "apparatus/library/shapes/common";
import { Color, Gradient, Path } from "paper";
export class Sphere {
    constructor() {
        this.drivers = [
            {
                type: "rectangle",
                minX: 5, maxX: 400,
                minY: 0, maxY: 0,
                toAppearance: (f, p) => f({
                    radius: p.x
                }),
                fromAppearance: a => P(a.radius, 0),
                scale: 1.0,
            }
        ];
    }
    render(appearance) {
        const { radius, shading } = appearance;
        const graphic = new Path.Circle(P(0, 0), radius);
        BasicShapes.applyCustom(appearance, (fill) => {
            graphic.fillColor = new Color(new Gradient(shadingGradient(shading, fill), true), P(-radius / 2, -radius / 2), P(0, 1.5 * radius).rotate(45));
        }, (width, stroke) => {
            graphic.withStroke(width, stroke);
        });
        return {
            graphic,
            hitShape: graphic.rectHitShape(),
        };
    }
}
Sphere.properties = {
    label: "Sphere",
    defaultAppearance: Object.assign(Object.assign({}, BasicShapes.defaultAppearance), { shading: "smooth", radius: 50 }),
    appearanceSpecs: [
        ...BasicShapes.specs,
        BasicShapes.header,
        {
            spec: "toggle-buttons", key: "shading", label: "Shading", size: "text",
            options: [
                { value: "smooth", label: "Smooth" },
                { value: "hard", label: "Hard" },
            ],
        }
    ],
};
function shadingGradient(shading, fill) {
    switch (shading) {
        case "smooth":
            return [
                [fill.color().ladd(35).hex(), 0.0],
                [fill, 0.9],
                [fill.color().ladd(-10).hex(), 1.0],
            ];
        case "hard":
            return [
                [fill.color().ladd(35).hex(), 0.3],
                [fill, 0.7],
                [fill.color().ladd(-10).hex(), 0.8],
            ];
    }
}
